<template>    
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeExamTake()">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title" v-if="type=='formal-evolution'" >
                                {{$t('1230')}}
                            </div>     
                             <div class="mdc-top-app-bar__title" v-else-if="type === 'regular-evolution'" >
                                {{$t('1231')}}
                            </div> 
                             <div class="mdc-top-app-bar__title" v-else>
                                {{$t('1232')}}
                            </div>              
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                    
                </header>
                
                <section class="flex-grow-1 scroll-y">
                    <div id="overlay" v-if="!timerPauseState && paperUseTimeout"></div>
                    <question-navi
                        :solves="solves"
                        :currentQuestion="currentQuestion"
                        @selectQuestionNavi="selectQuestionNavi"
                        ></question-navi>
                    <!-- {{currentQuestion}} -->
                    <!-- {{answers}} -->
                    <component v-if="currentQuestion" ref="questionComp"
                        :is="currentQuestion.type.value" 
                        :question="currentQuestion"
                        :groupQuestionCount="currentGroupQuestionCount"
                        :groupQuestionTitle="currentGroupQuestionTitle"
                        :setedAnswer="answers[currentQuestion.id]"
                        :currentQuestionCheckStatus="currentQuestionCheckStatus"
                        :paperLevel="paperLevel"
                        @setAnswers="setAnswers"
                        @checkIsCheckeds="checkIsCheckeds"
                        :key="currentQuestion.id"
                    >
                    </component>
                </section>

                <section>
                    <!-- <hr class="divider"> -->

                    <div class="flex-row d-flex justify-content-between align-items-center pdt-8 pdb-8 pdl-8 pdr-8 bottom-shadow">
                        <div>
                            <button class="mdc-button btn-white t-color-secondaryBtnText" @click="previous()" v-if="showBtnPrev()">
                                <i class="material-icons mdc-button__icon">keyboard_arrow_left</i>
                                {{$t('1245')}}
                                <!--  -->
                            </button>
                        </div>


                        <div>
                            <question-timer 
                                v-if="paperUseTimeout"
                                :time="paperTimeout" 
                                @timerState="timerState" 
                                @timerEnd="timerSubmit"
                            ></question-timer>
                        </div>
                        
                        <div> 
                            <!-- {{currentIsCheckedButton}}
                                flag{{flag}} -->
                            <!-- <div  v-if="this.paper.length == this.currentGroupIndex+1 && (flag===false && currentIsCheckedButton==false || flag===true && currentIsCheckedButton==true)"> -->
                            <div  v-if="this.paper.length == this.currentGroupIndex+1 && (flag===false && currentIsCheckedButton==false)">
                                <button v-if="flag===false && currentIsCheckedButton==false" class="mdc-button mdc-button--raised btn-red t-color-appbarText" @click="check()">
                                    {{$t('3066')}}   
                                </button>

                                <!-- <button v-if="flag===false && currentIsCheckedButton==false" class="mdc-button mdc-button--raised btn-red t-color-appbarText" @click="check()">
                                    {{$t('3066')}}   
                                </button> -->
                                
                                <!-- <button class="mdc-button mdc-button--raised btn-red" @click="submit()">
                                {{$t('50014')}}
                                </button> -->
                            </div>
                            <div v-else>
                                <div v-if="this.paper.length == this.currentGroupIndex+1">
                                    <button class="mdc-button mdc-button--raised btn-red t-color-appbarText" @click="check()" v-if="showBtnCheck()" :disabled="!currentQuestionSolvedStatus">
                                    <!-- <button class="mdc-button mdc-button--raised btn-red t-color-appbarText" @click="check()" v-if="showBtnCheck() && !currentIsCheckedButton" :disabled="!currentQuestionSolvedStatus"> -->
                                        <!-- {{$t('1246')}} -->
                                        {{$t('3066')}}
                                        <!-- CHECK -->
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="mdc-button mdc-button--raised btn-red t-color-appbarText" @click="check()" v-if="showBtnCheck() && !currentIsCheckedButton" :disabled="!currentQuestionSolvedStatus">
                                        <!-- {{$t('1246')}} -->
                                        {{$t('3066')}}
                                        <!-- CHECK -->
                                    </button>
                                </div>
                                <!-- {{isCheckButton}} -->
                                <div v-if="this.paper.length == this.currentGroupIndex+1">
                                    <button class="mdc-button btn-white t-color-secondaryBtnText" @click="next()" v-if="showBtnNext()">
                                        <!-- {{$t('1247')}} -->
                                        {{$t('1246')}}
                                        <!-- NEXT -->
                                        <i class="material-icons mdc-button__icon">keyboard_arrow_right</i>
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="mdc-button btn-white t-color-secondaryBtnText" @click="next()" v-if="showBtnNext() || currentIsCheckedButton">
                                    <!-- <button class="mdc-button btn-white t-color-secondaryBtnText" @click="next()" v-if="showBtnNext() || currentIsCheckedButton"> -->
                                        <!-- {{$t('1247')}} -->
                                        {{$t('1246')}}
                                        <!-- NEXT -->
                                        <i class="material-icons mdc-button__icon">keyboard_arrow_right</i>
                                    </button>
                                </div>
                                <button class="mdc-button mdc-button--raised btn-red" @click="submit()" v-if="showBtnSubmit()">
                                    {{$t('50014')}}
                                    <!-- 제출 -->
                                </button>
                            </div>
                            
                        </div>

                    </div>
                </section>
            </div>
        </div>
    </div>
    
</template>


<script>
/**
 * 시험 응시 컴포넌트(exam take component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import QuestionNavi from './QuestionNavi.vue'
import Timer from './question/Timer.vue'
import {examMixin} from '@/mixins/exam.js'
import {MDCRipple} from '@material/ripple'

export default {
    data() {
        return {
            examTitle: '',
            currentQuestion: null,
            paperTimeout: false,
            paperUseTimeout: 0,
            paperLevel: '',
            window: null,
            paper: [],
            answers: {},
            solves: [],
            questionSequence: '',
            questionGroup: null,

            currentGroupIndex: 0,
            currentQuestionIndex: 0,
            currentGroupQuestionCount: 0,
            currentQuestionCheckStatus: false,
            currentQuestionSolvedStatus: false,

            timerPauseState: false,
            type:null,
            currentIsCheckedButton:false,
            answerTrueOrFalse :true,
            flag : false,
            fillinRange:''
            //indexIsCheckedButton: false,
        }
    },
    mixins: [examMixin],

    components: {
        'question-navi': QuestionNavi,
        'question-timer': Timer,
        'SHORT_ANSWER': () => import('./question/ShortAnswer.vue'),
        'CHOICE_SINGLE': () => import('./question/ChoiceSingle.vue'),
        'TRUE_OR_FALSE': () => import('./question/ChoiceSingle.vue'),
        //'TRUE_OR_FALSE': () => import('./question/TrueandFalse.vue'),
        'CHOICE_MULTIPLE': () => import('./question/ChoiceMultiple.vue'),
        'FILL_IN_THE_RANGE': () => import('./question/FillInTheRange.vue'),
        'FILL_IN_THE_BLANK': () => import('./question/FillInTheBlank.vue'),
        'ESSAY': () => import('./question/Essay.vue'),

    },
    watch:{

        solves (newVar, oldVar) {
            //let solvesIndex = _.findIndex(this.solves, ({questionId: answer.questionId}))
            let solvesIndex1 = this.solves.findIndex(element => element.questionId == this.currentQuestion.id)
            this.currentIsCheckedButton = this.solves[solvesIndex1].isCheckButton
            // console.log('this.currentIsCheckedButton',this.currentIsCheckedButton)
            console.log('newVar',newVar)
            console.log('oldVar',oldVar)
        }
        
    },
    

    mounted() {
        this.type=this.$route.query.type;
        this.setExamPaper()
        this.setMaterialUi()
        
    },
    
    methods: {
        // set paper data
        setExamPaper() {
            const params = {
                examineeId: this.$route.params.examineeId
            }
            
            // set exam start
            examApi.start(params).then((response) => {
                // console.log('start', response.data.data);
                // get exam paper information
                return examApi.window(params)
            })
            .then((response) => {
                // console.log('window', response.data.data);
                this.window = response.data.data
                this.paperTimeout = this.window.timeout                
                this.paperUseTimeout = this.window.useTimeout
                this.questionSequence = this.window.questionSequence.value
                this.paperLevel = this.window.level ? this.window.level.text : ''
                this.examTitle = this.window.name                
                
                // get exam question & set data
                examApi.groups(params).then((response) => {                    
                    this.paper = response.data.data                    
                    let number = 1
                    _.each(this.paper, (group, groupIndex) => {
                        _.each(group.questions, (question, questionIndex) => {
                            question.groupIndex = groupIndex
                            question.questionIndex = questionIndex
                            question.number = number++
                            question.groupId = group.id
                        })
                    })                  

                    this.setCurrentQuestion()
                    this.initAnswers()
                })
            })
        },

        getQuestionGroup() {
            this.questionGroup = this.paper[this.currentQuestionIndex]
        },

        setCurrentQuestion() {
            this.$hideLoading();
            
            this.currentQuestion = null
             
            this.currentQuestionSolvedStatus = false
            this.currentQuestion = this.paper[this.currentGroupIndex].questions[this.currentQuestionIndex]
            this.currentGroupQuestionCount = this.paper[this.currentGroupIndex].questions.length
            this.currentGroupQuestionTitle = this.paper[this.currentGroupIndex].name


            //!this.answers[this.currentQuestion.id].isSolve


            
            
            // if (!this.answers[this.currentQuestion.id].isSolve) {
            //     this.currentQuestionCheckStatus = true;

            // }else{
            //     this.currentQuestionCheckStatus = false

            // }

            ///console.log('this.currentQuestion',this.currentQuestion)
        },

        setCurrentQuestionPriv() {
    
            this.currentQuestion = null
             
            this.currentQuestionCheckStatus = true;
            this.currentQuestionSolvedStatus = false
            this.currentQuestion = this.paper[this.currentGroupIndex].questions[this.currentQuestionIndex]
            this.currentGroupQuestionCount = this.paper[this.currentGroupIndex].questions.length
            this.currentGroupQuestionTitle = this.paper[this.currentGroupIndex].name

            ///console.log('this.currentQuestion',this.currentQuestion)
        },

        isFirst() {
            return this.currentGroupIndex || this.currentQuestionIndex
        },

        isGroup() {
            return this.paper[this.currentGroupIndex].questions.length > 1 ? true : false
        },

        isLastGroupQuestion() {
            return this.paper[this.currentGroupIndex].questions.length === this.currentQuestionIndex+1 ? true : false
        },

        isGroupLast(){
            return this.paper.length === this.currentGroupIndex+1 ? true : false
        },

        isChecked() {
            return this.answers && this.currentQuestion ? this.answers[this.currentQuestion.id].checkStatus : false
        },

        showBtnCheck() {
            return !this.currentQuestionCheckStatus
        },

        showBtnNext() {
            
            return this.currentQuestionCheckStatus && (!this.isGroupLast() || !this.isLastGroupQuestion())
        },

        showBtnPrev() {
            return this.isFirst()
        },

        showBtnSubmit() {
            
            return this.currentQuestionCheckStatus && this.isGroupLast() && this.isLastGroupQuestion()
        },



        check() {
            if (this.questionSequence === 'SEQUENTIAL') {
                // is sequentially
                if (!this.answers[this.currentQuestion.id].isSolve) {
                    // 다음으로 넘어갈 수 없음(Unable to move to)
                    this.$alert({
                        title: this.$t('990'),  //문항 풀이 후 다음 문항으로 이동할 수 있습니다.
                        content: this.$t('991') + this.$t('992'),   //이 시험은 문항을 순차적으로 풀이해야 합니다. 문항을 풀이하고 다음 문항으로 이동해주세요.
                        accept:  this.$t('993') //확인
                    }).then(() => {})
                    return 
                }
            }
            this.currentQuestionCheckStatus = true
            let solvesIndex1 = this.solves.findIndex(element => element.questionId == this.currentQuestion.id)
            this.solves[solvesIndex1].isCheckButton = true
            //this.solves = JSON.parse(JSON.stringify(this.solves))
            //console.log('solvesIndex1',this.solves)
        },

        // move question naviagation
        selectQuestionNavi(data) {
            // 순차 풀이 일 경우 문항 이동 불가능
            if (this.questionSequence === 'SEQUENTIAL') {   //순차 풀이 일 경우
                // is sequentially
                // 다음으로 넘어갈 수 없음(Unable to move to)                
                this.$alert({
                    title: this.$t('990'),  //문항 풀이 후 다음 문항으로 이동할 수 있습니다.
                    content: this.$t('991') + this.$t('992'),   //이 시험은 문항을 순차적으로 풀이해야 합니다. 문항을 풀이하고 다음 문항으로 이동해주세요.
                    accept:  this.$t('993') //확인
                }).then(() => {})
                return
            }else {
                // is not sequentially
                this.currentGroupIndex = data.groupIndex
                this.currentQuestionIndex = data.questionIndex                
                this.setCurrentQuestion()
            }
            
        },

        next() {
            //this.hideCheckButton = true
            
            let solvesIndex = this.solves.findIndex(element => element.questionId == this.currentQuestion.id)
            this.solves[solvesIndex].isSolve = this.answers[this.currentQuestion.id].isSolve
            console.log('solvesIndex',this.solves)
            this.solves.push()
            
            if (this.isGroup()) {
                // 그룹문항(is group)
                if (this.isLastGroupQuestion()) {
                    // is group last question
                    this.currentGroupIndex++
                    this.currentQuestionIndex = 0
                }else {
                    // is not group last question
                    this.currentQuestionIndex++
                }
            }else {
                // 그룹문항(is not group)
                this.currentGroupIndex++
                this.currentQuestionIndex = 0
            }
            this.setCurrentQuestion()
        },

        previous() {            
            if (this.isGroup()) {  
                // 그룹문항(is group)              
                if (!this.currentQuestionIndex) { 
                    // 그룹내 마지막 문항(is group last question)
                    this.currentQuestionIndex = this.paper[this.currentGroupIndex-1].questions.length-1
                    this.currentGroupIndex--
                }else { 
                    // 그룹내 이전 문항(is not group last question)
                    this.currentQuestionIndex--
                }
            } else{
                // 그룹문항 아님(is not group)
                this.currentQuestionIndex = this.paper[this.currentGroupIndex-1].questions.length-1
                this.currentGroupIndex--
            }

            this.setCurrentQuestionPriv()
        },

        timerSubmit() {            
            this.$alert({
                title: this.$t('1266'), //응시 시간이 종료되었습니다.
                content: this.$t('1267') + '<br>' + this.$t('1268'),    //시험의 응시 시간이 모두 지났습니다. 현재까지 풀이한 문항을 제출합니다.
                accept: this.$t('1269') //확인
            }).then(() => {
                this.$router.push('/independent/exam?listType=my')
                //this.submit()
            }).catch(() => {
                
            })
        },

        // 시험지 답안 제출(exam submit)
        submit() {
            // console.log('최종제출')
            this.$showLoading();
            let params = {
                examineeId: this.$route.params.examineeId,
                answers: this.answers
            }
            this.$hideLoading();
            if(this.questionSequence === 'SELECTIONAL') {
                 //this.$hideLoading();
                for (var prop in this.answers) {
                    if(this.answers[prop].isSolve==false){
                        this.answerTrueOrFalse = false
                        console.log('this.answers[prop].isSolve',this.answers[prop].isSolve)
                    }
                }
                 
                //  console.log('this.answerTrueOrFalse',this.answerTrueOrFalse)
                //  return
                if(this.answerTrueOrFalse == false){
                    this.$confirm({
                        title: this.$t("3190"),
                        content: this.$t('3191')+'<br>'+this.$t('3192'),
                        accept: this.$t("3194"),
                        cancel: this.$t("3193"),
                    }).then(() => {
                        this.finalSubmission(params)
                            //this.$router.push("/emailvarification");
                    }).catch(() => {
                            //this.$router.push("/login");
                    });
                    
                } else {
                    this.finalSubmission(params)
                }
            } else {
                this.finalSubmission(params)
            }
            
        },

        finalSubmission(params) {
            this.$showLoading();
            examApi.submit(params).then((response) => {
                this.$hideLoading();
                let submitResult = response.data.data
                let alertData = {}
                console.log('submitExm')
                console.log('submitExm',submitResult)
                if (submitResult.exposure) {
                   
                    // 결과보기 가능(Available to view results)
                    alertData = {
                        title: '',
                        content: this.$t('50015'), //'TODO-제출이 완료되었습니다. 성적조회가 가능합니다. 성적을 조회하시겠습니까?',
                        accept: this.$t('50017'), //'TODO-확인',
                        cancel: this.$t('50018'), //'TODO-취소'
                    }
                    this.$showLoading();
                    ///alert('dd');
                    examApi.independentExamineeExamView({
                        examineeId: this.$route.params.examineeId,
                        application: true
                    }).then((response) => {
                        this.$hideLoading();
                        let paperData = response.data.data
                        let periodPolicy = paperData.period

                        this.$confirm(alertData).then(() => {
                            if( periodPolicy && periodPolicy.scoreConfirm ){
                                this.moveExamResult()
                            }else{
                                this.$router.push('/independent/exam?listType=result')
                            }
                        }).catch(() => {
                            this.$hideLoading();
                            this.routerGoPrev()
                        })

                    })

                    
                }else {
                    // 결과보기 불가능(Unable to see results)
                    ///alert('ddqq');
                    this.$showLoading();
                    examApi.independentExamineeExamView({
                        examineeId: this.$route.params.examineeId,
                        application: true
                    }).then((response) => {
                        this.$hideLoading();
                        let paperData = response.data.data
                        let periodPolicy = paperData.period

                        alertData = {
                            title: '',
                            content: this.$t('50016'), //'TODO-제출이 완료되었습니다. 결과는 성적 조회기간에 가능합니다.',
                            accept: this.$t('50017'), //'TODO-확인',
                            cancel: this.$t('50018'), //'TODO-취소'
                        }
                        this.$alert(alertData).then(() => {
                            
                            if(periodPolicy && periodPolicy.scoreConfirm && periodPolicy.scoreConfirm.start <= Date.now() && Date.now() <= periodPolicy.scoreConfirm.end ){
                                this.moveExamResult()
                            }else{
                                this.$router.push('/independent/exam?listType=result')
                            }
                        }).catch(() => {this.$hideLoading();})


                    })

                    
                    
                }
                
                
            }).catch((err) => {
                let responseData = err.response.data.meta
                let alertMessage = this.$t('50019') //'TODO-시험지 제출 중 오류가 발생하였습니다. 다시 응시해 주시기 바랍니다.'
                if (responseData.errCode === '2201') {
                    alertMessage = this.$t('50020') // this.$t('TODO-이미 재출한 시험지 입니다.')
                }
                this.$alert({content: alertMessage, accept: this.$t('50021')}).then(() => {
                   // this.$router.go(-1)
                })
            })
        },

        // 답안지 설정(Set Answer Paper)
        setAnswers(answer) { 
            console.log('answer',answer)
            this.answers[answer.questionId] = {
                text: answer.text,
                selected: answer.selected,
                texts: answer.texts,
                startDate: answer.startDate,
                solveTime: answer.solveTime,
                isSolve: answer.isSolve,
                // checkStatus: false
            }
            
            //상단 문항 풀이 상태 네비게이션 설정위한 값 설정
            let solvesIndex = _.findIndex(this.solves, ({questionId: answer.questionId}))
            // console.log('ssssssssssss',this.paper.length,this.currentGroupIndex+1)
            // console.log('solvesIndex',solvesIndex)
            // console.log('ssssssssssssKKKKKKKKKKKK',this.answers[answer.questionId].isSolve)
            if(this.paper.length == this.currentGroupIndex+1 && this.answers[answer.questionId].isSolve==true) {
                //console.log('if=>>>>ddddddddddd')
                this.flag = true
            } 
            //this.solves[solvesIndex].isSolve = answer.isSolve
            this.solves[solvesIndex].isSolve = false
            this.solves.push()
            console.log('setAnswers',this.solves)
            this.currentQuestionCheckStatus = false
            if (answer.isSolve) {
                this.currentQuestionSolvedStatus = true

            }else {
                this.currentQuestionSolvedStatus = false
            }
            //this.answers.push()
            // console.log('this.answers', this.answers)
            
        },
        checkIsCheckeds(answer){
            console.log('checkIsCheckeds',answer)
            let solvesIndex = _.findIndex(this.solves, ({questionId: answer.questionId}))
            this.solves[solvesIndex].isCheckButton = false
            if(this.paper.length == this.currentGroupIndex+1) {
                this.fillinRange = this.solves[solvesIndex].text
            } else {
                this.fillinRange = ''
            }
        },
        // 답안지 초기 설정(Initialize Answer Paper)
        initAnswers() {
            let questionsData = _.chain(this.paper)
                .map(function (item) {
                    return item.questions;
                })
                .flatten()
                .map(function (question, index) {
                    return question
                }).value()

            // 문항 유형에 따라 답안지 설정(Set the answer sheet according to the question type)
            _.each(questionsData, (question) => {
                // console.log(question);
                this.answers[question.id] = {
                    text: '',
                    selected: _(question.choices.length).times(() => {return false}),
                    texts: question.blank ? _(question.blank.items.length).times(() => {return ''}) : [],
                    isSolve: false,
                    // checkStatus: false
                }

                this.solves.push({
                    questionId: question.id,
                    isSolve: false,
                    isCheckButton: false,
                    groupIndex: question.groupIndex,
                    questionIndex: question.questionIndex,
                })
            })
        },

        // 시험 종료 팝업(exam close popup)
        closeExamTake() {
            this.$confirm({
                title: this.$t('985'),  //시험을 종료하시겠습니까?
                content: this.$t('986') + '<br>' + this.$t('987'),  //시험 종료 시 현재까지 풀이한 문항은 제출되지 않습니다. 확인을 누르면 시험이 종료됩니다.
                accept:  this.$t('989'),    //확인
                cancel:  this.$t('988'),    //취소
            }).then(() => {
                this.routerGoPrev()
            }).catch(() => {})
        },

        timerState(state) {
            this.timerPauseState = state
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>
<style scoped>
.t-subtitle5 .MathJax span{
    font-family: "Roboto", "KhmerOS_sys", sans-serif !important; font-style: normal!important;}
</style>